
import { Component, OnInit, Input } from '@angular/core';
import { ListingTimelineable } from 'app/models/listing-timeline';
import { MapService } from 'app/services/map.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'listing-map',
  templateUrl: './listing-map.component.html',
  styleUrls: ['./listing-map.component.scss']
})
export class ListingMapComponent implements OnInit {

  @Input() listingTimeline: ListingTimelineable;

  constructor(private mapService: MapService) { }

  apiLoaded: Observable<boolean>;
  center: google.maps.LatLngLiteral;
  zoom = 16;
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
  };


  ngOnInit() {
    this.apiLoaded = this.apiLoaded = this.mapService.initGoogleMapsApi();
    this.center = { lat: this.listingTimeline.latitude, lng: this.listingTimeline.longitude };
    this.markerOptions.icon = 'assets/houwzer/pins/' + this.listingTimeline.pin_image_filename;
  }
}
